import { format } from 'date-fns'
import React, { useState, useEffect, useContext } from 'react'
import Spinner from '../../../components.js/elements/Spinner'
import HeaderReturn from '../../../components.js/serveur/siteWeb/HeaderReturn'
import { useLocation } from 'react-router-dom'
import ViewDaysStaff from '../../../components.js/serveur/staff/ViewDaysStaff'
import useFirebase from './../../../firebase/useFirebase'
import ModalHoursStaff from '../../../components.js/serveur/staff/ModalHoursStaff'
import useForm from '../../../hooks/useForm' 
import { AppContext } from '../../../App'

const INITIAL_STATE = {
    hoursAMStart:'0',
    minutesAMStart:'0',
    hoursAMEnd:'0',
    minutesAMEnd:'0',
    hoursPMStart:'0',
    minutesPMStart:'0',
    hoursPMEnd:'60',
    minutesPMEnd:'0',
    nbrWeeks:'0',
}

const HorairesStaff = () => {
    const { user } = useContext(AppContext)
    const [montage, setMontage] = useState(true)
    const { updateData, writeData, readStaffDatesOff, deleteData, readData, staff, datesOff } = useFirebase()
    const { handleChange, values, setValues } = useForm(INITIAL_STATE)
    const location = useLocation()
    const { state } = location
    const [choiceDay, setChoiceDay] = useState()
    const [count, setCount] = useState(1)

    useEffect(() => {
        readData(user.uid)
        window.scrollTo(0, 0)
        setMontage(false)
    },[]) 

    if (montage) return <Spinner />

    //  jours ouverts fermé
    const handleOpenDay = (day,id,openDay) => {
        const data = {[day+'open']:openDay === 'ouvert' ? true : false}
        updateData('entreprises/'+user.uid+'/staff/'+state.idStaff,data)
    }

    const _updateHoursStaff = () => {
        const data = {
            [choiceDay+'hoursAMStart']: values.hoursAMStart,
            [choiceDay+'minutesAMStart']: values.minutesAMStart,
            [choiceDay+'hoursAMEnd']: values.hoursAMEnd,
            [choiceDay+'minutesAMEnd']: values.minutesAMEnd,
            [choiceDay+'hoursPMStart']: values.hoursPMStart,
            [choiceDay+'minutesPMStart']: values.minutesPMStart,
            [choiceDay+'hoursPMEnd']: values.hoursPMEnd,
            [choiceDay+'minutesPMEnd']: values.minutesPMEnd,
        }
        updateData('entreprises/'+user.uid+'/staff/'+state.idStaff,data)
        setValues(INITIAL_STATE)
        _heuresMinutesOK()
    }

    const _heuresMinutesOK = () => {
        if (
            parseInt(values.hoursAMStart) < 0 || parseInt(values.hoursAMStart) > 23 ||
            parseInt(values.minutesAMStart) < 0 || parseInt(values.minutesAMStart) > 59 ||
            parseInt(values.hoursAMEnd) < 0 || parseInt(values.hoursAMEnd) > 23 ||
            parseInt(values.minutesAMEnd) < 0 || parseInt(values.minutesAMEnd) > 59 ||
            parseInt(values.hoursPMStart) < 0 || parseInt(values.hoursPMStart) > 23 ||
            parseInt(values.minutesPMStart) < 0 || parseInt(values.minutesPMStart) > 59 ||
            parseInt(values.hoursPMEnd) < 0 || parseInt(values.hoursPMEnd) > 23 ||
            parseInt(values.minutesPMEnd) < 0 || parseInt(values.minutesPMEnd) > 59 
        ) {
            return 'il y a une erreur dans les heures ou les minutes'
        } 

        if (
            values.amOpenDay === true &&
            _convertMinutes(values.hoursAMStart,values.minutesAMStart) >= _convertMinutes(values.hoursAMEnd,values.minutesAMEnd)
        ) { return "l'heure de début doit être inférieur à l'heure de fin" }

        if (
            values.pmOpenDay === true &&  
            _convertMinutes(values.hoursPMStart,values.minutesPMStart) >= _convertMinutes(values.hoursPMEnd,values.minutesPMEnd)
        ) { return "l'heure de début doit être inférieur à l'heure de fin" }
    }

    const _convertMinutes = (h,m) => {
        const heures = parseInt(h) * 60
        const minutes = parseInt(m)
        const sum = parseInt(heures+minutes)
        return sum
    }

    const updateAmPm = (id, response) => {
        const data = {[id]:response}
        updateData('entreprises/'+user.uid+'/staff/'+state.idStaff,data)
    }

    const _numberWeeks = () => {
        if (parseInt(values.nbrWeeks) === 0 || parseInt(values.nbrWeeks) > 8) {
            return 'le nombre de semaines doit être entre 1 et 12'
        }
    }

    const _updateNbrWeeks = () => {
        const data = {nbrWeeks:values.nbrWeeks}
        updateData('entreprises/'+user.uid+'/staff/'+state.idStaff,data)
    }

    const _updateDates = (start, end) => {
        const startDate = format(new Date(start), 'MM/dd/yyyy')
        const endDate = format(new Date(end), 'MM/dd/yyyy')
        const dateDebut = format(new Date(start), 'dd/MM/yyyy')
        const dateFin = format(new Date(end), 'dd/MM/yyyy')
        const data = {startDate:startDate, endDate:endDate, idStaff:state.idStaff,dateDebut:dateDebut,dateFin:dateFin}
        writeData('entreprises/'+user.uid+'/datesOff/',data)
    }

    const _delete = (id) => {
        deleteData('entreprises/'+user.uid+'/datesOff/'+id)
    }
    
    const _subtractNbrWeeks = (nbrWeeks) => {
        if (nbrWeeks > 0) {
            const data = {nbrWeeks:nbrWeeks - 1}
            updateData('entreprises/'+user.uid+'/staff/'+state.idStaff,data)
        }
    }

    const _addNbrWeeks = (nbrWeeks) => {
        if (nbrWeeks < 8) {
            const data = {nbrWeeks:nbrWeeks + 1}
            updateData('entreprises/'+user.uid+'/staff/'+state.idStaff,data)
        }
    }

    return (
        <div className='container-fluid'> 
            <HeaderReturn
                title={'Horaires ' + state.surnameStaff +' ' + state.nameStaff} 
                link='/staff'
            />
            <ViewDaysStaff
                state={state}
                staff={staff}
                handleOpenDay={handleOpenDay}
                setChoiceDay={setChoiceDay} 
                setCount={setCount}
                count={count}
                datesOff={datesOff}
                _delete={_delete}
                _subtractNbrWeeks={_subtractNbrWeeks}
                _addNbrWeeks={_addNbrWeeks}
            /> 
            <ModalHoursStaff
                handleChange={handleChange}
                values={values}
                setValues={setValues}
                staff={staff}
                state={state}
                _updateHoursStaff={_updateHoursStaff}
                updateAmPm={updateAmPm}
                choiceDay={choiceDay}
                count={count}
                _heuresMinutesOK={_heuresMinutesOK}
            />
         </div>
    )
}

export default HorairesStaff












